import { render, staticRenderFns } from "./Khazna.vue?vue&type=template&id=4969aa9d"
import script from "./Khazna.vue?vue&type=script&lang=js"
export * from "./Khazna.vue?vue&type=script&lang=js"
import style0 from "./Khazna.vue?vue&type=style&index=0&id=4969aa9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports